import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=4fe5c01e&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=4fe5c01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe5c01e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fe5c01e', component.options)
    } else {
      api.reload('4fe5c01e', component.options)
    }
    module.hot.accept("./nav.vue?vue&type=template&id=4fe5c01e&scoped=true&", function () {
      api.rerender('4fe5c01e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/nav.vue"
export default component.exports